import { useCallback } from 'react';

import { useConditionState } from './useConditionState';

export const useValuesState = () => {
  const { condition, setCondition } = useConditionState();
  const values = 'values' in condition ? condition.values : undefined;
  const setValues = useCallback(
    (newValues?: string[]) =>
      setCondition((currentCondition) => ({ ...currentCondition, values: newValues })),
    [setCondition],
  );
  return { values, setValues };
};
